// Styles for ListView go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledListView = styled.div`
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .hotel-card-container {
    border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
  }

  .list-mini-card-container {
    border-bottom: none;
  }

  @media only ${baseVariables.mediaQuery.md} {
    .hotel-card-container {
      border-bottom: none;
    }

    .list-mini-card-container {
      border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
    }
  }

  .pagination-container {
    margin-top: 0 !important;
  }

  .paginated-group:last-of-type {
    margin-bottom: 0 !important;
  }

  @media only ${baseVariables.mediaQuery.lg} {
    .pagination-container {
      margin-top: ${toRem(16)} !important;
    }
  }
`;
